import React from 'react';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import { StarRating } from '../../Reviews';
import { OwnerProfile } from '../../../types/owner';
import OwnerSocialLinks from './OwnerSocialLinks';
import OwnerLogoUpload from './OwnerLogoUpload';
import OwnerBio from './OwnerBio';

const OwnerProfileSummary = ({
    owner,
    canEdit = false,
}: {
    owner: OwnerProfile;
    canEdit?: boolean;
}) => {
    return (
        <section aria-label='Owner profile summary'>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'flex-start', md: 'center' },
                    gap: 2,
                    justifyContent: 'space-between',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: { xs: 2, md: 4 },
                    }}
                >
                    {canEdit ? (
                        <OwnerLogoUpload owner={owner} />
                    ) : (
                        <Avatar
                            sx={{ width: 125, height: 125 }}
                            src={owner.logo?.src}
                            alt={`${owner.name} logo`}
                        />
                    )}
                    <div>
                        <Typography variant='h2'>{owner.name}</Typography>
                        {owner.reviewCount > 0 ? (
                            <Stack direction='row' spacing={1}>
                                <StarRating
                                    rating={owner.averageRating || 0}
                                    size='small'
                                />
                                <Typography variant='body2'>
                                    {Number(owner.averageRating || 0).toFixed(
                                        1,
                                    )}{' '}
                                    · {owner.reviewCount} review
                                    {owner.reviewCount === 1 ? '' : 's'}
                                </Typography>
                            </Stack>
                        ) : (
                            <Typography variant='body2' color='text.secondary'>
                                No published host reviews yet
                            </Typography>
                        )}
                    </div>
                </Box>
                <OwnerSocialLinks owner={owner} canEdit={canEdit} />
            </Box>
            <OwnerBio owner={owner} canEdit={canEdit} />
        </section>
    );
};

export default OwnerProfileSummary;
